import styled from 'styled-components';

export const Logo = styled.img`
  width: 140px;
  max-width: 100%;
  height: 46px;
  display: block;
  align-self: center;
  justify-content: center;
  object-fit: contain;
  margin-top: 22px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 73px;
    height: 37px;
    margin-top: 20px;
  }
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.palette.darkGrey};
  display: block;
  margin: 0 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
    margin-bottom: 10px;
    text-overflow: clip;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const PromotionTitle = styled(Title)`
  height: 36px;
  line-height: 18px;
  text-overflow: clip;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 32px;
    line-height: 16px;
  }
`;

export const Description = styled.span`
  font-size: 12px;
  display: block;
  text-align: left;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-left: 10px;
  width: calc(100% - 15px);
  display: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
    width: 95%;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    font-size: 10px;
  }
`;

export const PromotionPopoverContent = styled.div`
  max-width: 316px;
  max-height: 180px;
  overflow-y: auto;
  white-space: normal;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.darkGrey};

  p {
    margin: 0;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 18px;
  }
`;

export const Seperator = styled.div`
  width: 80%;
  height: 1px;
  margin: 22px 20px 20px 20px;
  display: flex;
  align-self: center;
  background-color: ${({ theme }) => theme.palette.lightBlueGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 4px 10px 3px;
  }
`;

export const PromotionsGrid = styled.div<{ $hasNavigation?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  gap: 20px;
  margin-bottom: ${({ $hasNavigation }) => ($hasNavigation ? '20px' : '0')};
  width: 100%;
  min-width: 0;
  white-space: normal;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    gap: 10px;
    margin-bottom: ${({ $hasNavigation }) => ($hasNavigation ? '16px' : '0')};
  }
`;

export const Wrapper = styled.div<{ isButton?: boolean }>`
  ${({ isButton }) => isButton && 'cursor: pointer'};
  position: relative;
  width: auto;
  min-width: 0;
  flex: 0 0 calc((100% - 60px) / 4);
  min-height: 138px;
  height: 152px;
  display: flex;
  margin: 0;
  flex-direction: column;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-basis: calc((100% - 40px) / 3);
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    flex-basis: calc((100% - 10px) / 2);
    height: 138px;
  }

  @media (max-width: 319px) {
    flex-basis: 100%;
  }
`;
